<template>
  <div
    class="tw-flex tw-items-center tw-w-full tw-h-full"
  >
    <div class="tw-flex-1">
      <el-input
        ref="Input"
        v-model="searchValue"
        type="search"
        class="clearable"
        :placeholder="$t('common.actions.search')"
        clearable
        @input="handleSearch"
      >
        <template #prefix>
          <icon-search />
        </template>
      </el-input>
    </div>
    <i-button
      v-if="showClose"
      size="medium"
      is-icon
      @click="$emit('close')"
    >
      <icon-close />
    </i-button>
  </div>
</template>

<script>
import _debounce from 'lodash/debounce';

export default {
  props: {
    showClose: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchValue: '',
    };
  },

  mounted() {
    if (this.$refs.Input) {
      this.$refs.Input.focus();
    }
  },

  methods: {
    handleSearch: _debounce(function() {
      this.$store.commit('v2/admin/messaging/set', ['fulltextSearchValue', '']);
      this.$store.commit('v2/admin/messaging/set', ['fulltextMessageId', null]);

      this.$store.commit('v2/admin/messaging/updateFilter', {
        field: 'body_search',
        payload: this.searchValue,
      });
    }, 500),
  },
};
</script>
